import { useQuery } from '@tanstack/react-query';
import { classes } from '@shared/api/services';

// Профиль преподавателя (queryKey общий с useTeacher — кэш переиспользуется).
// Нужен, чтобы конвертировать сырое время слота в таймзону зрителя
// и определять название инструмента по instrument_id.
const useTeacherQuery = (slug) =>
  useQuery({
    queryKey: ['teacher', slug],
    queryFn: async () => (await classes.getTeacher(slug)).data,
    enabled: !!slug,
  });

export const useTeacherTimezone = (slug) => {
  const { data, ...rest } = useTeacherQuery(slug);
  return { data: data?.timezone, ...rest };
};

export const useTeacherInstruments = (slug) => {
  const { data, ...rest } = useTeacherQuery(slug);
  return { data: data?.instruments, ...rest };
};
